import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const PrivacyPolicyPage = () => {
  return <SanityContentPage slug='privacy-policy' />
}

export default PrivacyPolicyPage
